import { Minus, Plus } from "lucide-react";
import React, { useEffect, useRef, useState } from "react";

const FaqCard = ({
  faqQuestion,
  faqAnswer,
  questionStyling,
  answerStyling,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (isOpen && contentRef.current) {
      setHeight(contentRef.current.scrollHeight);
    } else {
      setHeight(0);
    }
  }, [isOpen]);
  return (
    <div
      onClick={() => setIsOpen(!isOpen)}
      className={`px-8 py-7 transition-all duration-300 border border-surface-dark rounded-2xl`}
    >
      <button className="flex justify-between items-center w-full text-left gap-4 ">
        <h3 className="text-[20px] leading-[26px] font-semibold">
          {faqQuestion}
        </h3>
        <span className="text-purple-600">
          {isOpen ? <Minus size={20} /> : <Plus size={20} />}
        </span>
      </button>
      <div
        ref={contentRef}
        style={{
          maxHeight: `${height}px`,
          overflow: "hidden",
          transition: "max-height 0.3s ease, opacity 0.3s ease",
          opacity: isOpen ? 1 : 0,
        }}
      >
        <div
          dangerouslySetInnerHTML={{ __html: faqAnswer }}
          className="mt-6 text-gray-700 text-[18px] leading-[26px] font-medium"
        ></div>
      </div>
    </div>
  );
};

export default FaqCard;
